import { LISTING_TXN_TYPE_OPTIONS } from '@/features/listings/definitions/txnType';
import { INQUIRY_TXN_TYPE_OPTIONS } from '@/features/inquiries/definitions/txnType';
import { ListingTxnType } from '@/features/listings/definitions/txnType';
import { InquiryTxnType } from '@/features/inquiries/definitions/txnType';

export type AdvertTxnType = ListingTxnType | InquiryTxnType;

export const ADVERT_TXN_TYPE_OPTIONS = [
    ...LISTING_TXN_TYPE_OPTIONS,
    ...INQUIRY_TXN_TYPE_OPTIONS,
] as const;

export type AdvertTxnTypeOption = (typeof ADVERT_TXN_TYPE_OPTIONS)[number];
